module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-form"
    }
  }, [_c('div', {
    staticClass: "cardHolder"
  }, [(_vm.getVisibleForm) ? _c('v-card', {
    staticClass: "main-form-div",
    style: ({
      'border-top': '2px solid ' + _vm.$store.state.campaign.color + '60'
    })
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "namefield",
    staticClass: "form-input input-style first-input",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "label": _vm.$t('name'),
      "rules": [function () { return !!_vm.client.name || _vm.$t('musttypename'); }],
      "error": _vm.errorCheck && _vm.client.name == '',
      "prepend-icon": "person",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.emailfield.focus($event)
      }
    },
    model: {
      value: (_vm.client.name),
      callback: function($$v) {
        _vm.$set(_vm.client, "name", $$v)
      },
      expression: "client.name"
    }
  })], 1), _vm._v(" "), (_vm.$store.state.campaign.show_email) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "emailfield",
    staticClass: "form-input input-style",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "label": _vm.$t('email'),
      "rules": [function () { return !!_vm.client.mail || _vm.$t('musttypemail'); }, function () { return _vm.emailRegex.test(_vm.client.mail) || _vm.$t('validemail'); }],
      "error": _vm.errorCheck && _vm.client.mail == '',
      "prepend-icon": "mail",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.customfield.focus($event)
      }
    },
    model: {
      value: (_vm.client.mail),
      callback: function($$v) {
        _vm.$set(_vm.client, "mail", $$v)
      },
      expression: "client.mail"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.campaign.custom_field.visible) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "customfield",
    staticClass: "form-input input-style",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "prepend-icon": "label",
      "label": _vm.$store.state.campaign.custom_field.text[_vm.$store.state.client.lang],
      "error": _vm.errorCheck && _vm.$store.state.campaign.custom_field.required && _vm.client.number == '',
      "required": _vm.$store.state.campaign.custom_field.required
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.messagefield.focus($event)
      }
    },
    model: {
      value: (_vm.client.number),
      callback: function($$v) {
        _vm.$set(_vm.client, "number", $$v)
      },
      expression: "client.number"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('v-text-field', {
    ref: "messagefield",
    staticClass: "form-input input-style",
    style: ({
      'color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "label": _vm.$t('message'),
      "rules": [function () { return !!_vm.client.initialMessage || _vm.$t('musttypemessage'); }],
      "error": _vm.errorCheck && _vm.client.initialMessage == '',
      "prepend-icon": "chat",
      "required": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.clickForm($event)
      }
    },
    model: {
      value: (_vm.client.initialMessage),
      callback: function($$v) {
        _vm.$set(_vm.client, "initialMessage", $$v)
      },
      expression: "client.initialMessage"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    style: ({
      'background-color': _vm.$store.state.campaign.color
    }),
    attrs: {
      "round": "",
      "small": "",
      "id": "btnEnviar"
    },
    on: {
      "click": _vm.clickForm
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$t('send')) + "  ")]), _vm._v(" "), _c('v-icon', {
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    }),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("send")])], 1)], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-949db288"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form.vue
// module id = 411
// module chunks = 2